this.<template>
    <b-container fluid class="flex-center">
        <b-container fluid class="p-4 shadow-lg">
        <b-row v-if="sector">
            <b-col cols="12" offset-md="1" md="3">
                <b-row class="py-2">
                    <b-col cols="12" class="text-center">
                        <h5>{{$t('sales.assigns.actions')}}</h5>
                    </b-col>
                </b-row>
                <b-row class="py-2 flex-center">
                    <b-col cols="12" class="py-2">
                        <b-btn v-b-modal.editSector class="float-right w-100"><span class="fa fa-edit mx-2"></span> {{$t('sectors.sector.buttons.edit')}}</b-btn>
                    </b-col>
                    <b-col cols="12" class="py-2">
                        <b-btn v-b-modal.deleteSector @click="" variant="danger" class="float-right w-100"><span class="fas fa-trash-alt mx-2"></span> {{$t('sectors.sector.buttons.delete')}}</b-btn>
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="12" offset-md="1" md="6" class="eventDash p-2 m-auto">
                <h4 class="text-center"> {{ sector.code }} </h4>
                <h5 class="mx-2">{{$t('sectors.modal.row')}}: {{sector.rows}}</h5>
                <h5 class="mx-2">{{$t('sectors.modal.spr')}}: {{sector.row_seats}}</h5>
            </b-col>
        </b-row>
        </b-container>


        <b-modal centered
                 no-close-on-backdrop
                 id="editSector"
                 title=""
                 hide-footer>
                 <template v-slot:modal-title>
                    {{$t('sectors.sector.title.edit')}}
                 </template>
            <b-form @submit.prevent="editSector()" data-vv-scope="editSector">

                <b-row>
                    <b-col cols="12">
                        <b-form-group label-for="sectorCode">{{$t('sectors.modal.code')}}
                            <b-form-input :state="validateState('editSector.sectorCode')"
                                          :class="{'is-invalid': veeErrors.has('editSector.sectorCode')}"
                                          v-model="sector.code" v-validate="'required|alpha_num'" id="sectorCode" ref="sectorCode" type="text" size="md" name="sectorCode"></b-form-input>
                            <span class="vvError">{{ veeErrors.first('editSector.sectorCode') }}</span>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" class="text-center">
                        <b-btn type="submit" :disabled="veeErrors.any('editSector')" ref="btnEdit" variant="primary" class="w-50">{{$t('sectors.sector.buttons.conf')}}</b-btn>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>

        <b-modal centered
                 id="deleteSector"
                 title=""
                 @ok="deleteSector"
                 ok-variant="danger">
                 <template v-slot:modal-title>
                    {{$t('sectors.sector.title.delete')}}
                 </template>
            <p class="my-4">{{$t('sectors.sector.title.msg')}}?</p>
        </b-modal>


    </b-container>
</template>

<script>
    // @ is an alias to /src

    export default {
        name: 'sector',
        data() {
            return {
                sector: {},
            }
        },
        methods: {
            validateState(ref) {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref)
                }
                return null
            },
            editSector(){
                this.$axios.post('sectors/updateById',{
                    params: {
                        id: this.sector.id,
                        sector: this.sector
                    }
                }).then(response => {
                    if(response.data.success) {
                        this.$toasted.global.success({
                            message : response.data.data.msg
                        });
                        this.$root.$emit('bv::hide::modal', 'editSector', '#btnEdit');
                    }else{
                        this.$toasted.global.err({
                            message : response.data.data.msg
                        });
                    }
                }).then(()=> {
                        this.$nextTick(() => {
                            this.veeErrors.clear();
                            this.$nextTick(() => {
                                this.$validator.reset();
                            });
                        });
                    }
                );
            },
            deleteSector(){
                this.$axios.post('sectors/deleteById',{
                        params: {
                            id: this.$route.params.id,
                            sector: this.sector
                        }
                    }
                ).then(response => {
                    if(response.data.success) {
                        this.$toasted.global.success({
                            message : this.$t(response.data.data.msg)
                        });
                        this.$router.push('/sectors/')
                    }else{
                        this.$toasted.global.err({
                            message : this.$t(response.data.data.msg)
                        });
                    }
                });
            },

        },

        created() {
            this.$axios.get('/sectors/getById',
                {
                    params: {
                        id: this.$route.params.id,
                    }
                }
            ).then(response => {
                if (response.data.success) {
                    this.sector = response.data.data;
                }
            });
            let self = this;
            this.interval = setInterval(function () {
            }, 3000);
        },
        destroyed(){
            clearInterval(this.interval);
        },
    };
</script>